import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrailersGridComponent } from './trailers-grid.component';
import {TabModule} from '../tab/tab.module';
import {DxDataGridModule, DxFormModule, DxPopupModule, DxSwitchModule} from 'devextreme-angular';
import {UserDomainsChooserModule} from '../user-domains/user-domains-chooser/user-domains-chooser.module';
import {GridDefaultModule, GridTitleModule, TagsViewerModule} from 'shared';
import {IconModule} from '@visurel/iconify-angular';



@NgModule({
  declarations: [TrailersGridComponent],
    imports: [
        CommonModule,
        TabModule,
        DxDataGridModule,
        UserDomainsChooserModule,
        GridTitleModule,
        DxSwitchModule,
        GridDefaultModule,
        IconModule,
        DxPopupModule,
        TagsViewerModule,
        DxFormModule
    ],
  exports: [TrailersGridComponent]
})
export class TrailersGridModule { }
